// NOSGER (Spiegel et al., 1999) — scoring from the D_NOSGER_Auswertungstool.xlsm
// workbook. 6 dimensions, each with a per-sex cut-off:
//   F column = computed sum (Summenwert)
//   G column = ♀ threshold (weiblich)
//   H column = ♂ threshold (männlich)
// A dimension is "auffällig" when sum >= cut-off for the patient's sex.

export const NOSGER_DIMENSIONS = [
  { key: "gedaechtnis",   labelFr: "Mémoire",             labelDe: "Gedächtnis" },
  { key: "iadl",          labelFr: "IADL",                labelDe: "IADL" },
  { key: "koerperpflege", labelFr: "Soins corporels",     labelDe: "Körperpflege" },
  { key: "stimmung",      labelFr: "Humeur",              labelDe: "Stimmung" },
  { key: "soziales",      labelFr: "Comportement social", labelDe: "Soziales Verhalten" },
  { key: "stoerendes",    labelFr: "Comportement perturbateur", labelDe: "Störendes Verhalten" },
];

// Resolve which threshold column applies. Prefers the patient's app-level
// gender; falls back to the Geschlecht ComboBox value (F17) from the workbook
// (1=blank, 2=männlich, 3=weiblich).
function resolveSex(patientGenre, genderCode) {
  if (patientGenre === "H") return "male";
  if (patientGenre === "F") return "female";
  if (genderCode === 2) return "male";
  if (genderCode === 3) return "female";
  return null;
}

export function calcNosger({ sums, thresholds, genderCode, patientGenre, lang = "de" }) {
  const sex = resolveSex(patientGenre, genderCode);
  const labelKey = lang === "fr" ? "labelFr" : "labelDe";
  const verdictLabel = (auffaellig) =>
    lang === "fr"
      ? auffaellig ? "anormal" : "normal"
      : auffaellig ? "auffällig" : "unauffällig";

  const resultData = [];
  const lines = [];
  let anyAuffaellig = false;
  let anyDecided = false;

  for (const dim of NOSGER_DIMENSIONS) {
    const sum = sums?.[dim.key];
    const thr = thresholds?.[dim.key];
    if (sum == null || !thr) continue;
    const cutoff = sex === "male" ? thr.male : sex === "female" ? thr.female : null;
    const label = dim[labelKey];

    let value;
    if (cutoff == null) {
      value = `${sum}`;
    } else {
      const auffaellig = sum >= cutoff;
      anyDecided = true;
      if (auffaellig) anyAuffaellig = true;
      value = `${verdictLabel(auffaellig)} (${sum}/${cutoff})`;
    }

    resultData.push({
      name: dim.key,
      label,
      value,
      italic: true,
    });
    lines.push(`${label}: ${value}`);
  }

  return {
    resultData,
    resultText: lines.join("\n"),
    sex,
    anyAuffaellig,
    anyDecided,
  };
}
